var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 1.2749C6.09604 1.2749 1.29688 6.06323 1.29688 11.9782C1.29688 17.8932 6.08521 22.6816 12.0002 22.6816C17.9044 22.6816 22.7035 17.8932 22.7035 11.9782C22.7035 6.06323 17.9044 1.2749 12.0002 1.2749ZM16.8535 10.1582L11.361 15.6507C11.1985 15.8132 10.9927 15.8891 10.7869 15.8891C10.581 15.8891 10.3752 15.8132 10.2127 15.6507L7.51521 12.9532C7.20104 12.6391 7.20104 12.1191 7.51521 11.8049C7.82938 11.4907 8.34938 11.4907 8.66354 11.8049L10.7869 13.9282L15.7052 9.0099C16.0194 8.69574 16.5394 8.69574 16.8535 9.0099C17.1677 9.32407 17.1677 9.84407 16.8535 10.1582Z",
    fill: "#53E3AC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckGreen);
export default __webpack_public_path__ + "static/media/icon_check_green.79e8d0ec.svg";
export { ForwardRef as ReactComponent };